module.exports = __webpack_public_path__ + "static/img/logo-todomath-for-web-cn@2x.f0ca5b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo-todomath-for-web-cn@2x.png
// module id = RRXt
// module chunks = 18